import type { MixedItemDist } from "@memorang/types";

import { isScreenshotMode } from "@constants/common";
import { getParentMetadata } from "@helpers/content/metadata";
/* -----------------Helpers & Hooks--------------- */
import { groupTagsByType } from "@helpers/content/tag";
import { randomizeDistribution } from "@helpers/mocked-helpers";
/* -----------------Child components--------------- */
import { getSectionTags } from "./tag";

const getDashboardData = (
	response: MixedItemDist,
	handleNavigateToIAP: () => void,
	groupByCategory?: boolean | null,
) => {
	const { contents, iconUrl, title, tags, freeTagIds } = response;
	const numItems = contents.reduce((a, c) => a + c.totalCount, 0);

	const metadata = getParentMetadata(contents);

	const { distribution } = metadata;

	const hasAccess = response.hasAccess;
	const tagsByType = groupTagsByType(tags, "Display", freeTagIds, hasAccess);
	const sectionTags = getSectionTags(
		numItems,
		tagsByType,
		handleNavigateToIAP,
		hasAccess,
	);

	const { high, low, medium, none } = distribution;
	const masteryPercentage = Math.round(
		(high / (high + none + low + medium)) * 100,
	);

	const sections = Object.keys(tagsByType)
		.filter((type) => tagsByType[type].length > 0)
		.map((type) => {
			return {
				...sectionTags[0],
				title: type,
				tags: tagsByType[type].sort((a, b) => a.title.localeCompare(b.title)),
			};
		});

	const finalSectionTags = groupByCategory
		? sections
				.map((section) => {
					const { tags } = section;
					const newTags = tags.map((tag) => {
						const { distribution } = tag;

						return {
							...tag,
							distribution: isScreenshotMode
								? randomizeDistribution(distribution)
								: distribution,
						};
					});
					return {
						...section,
						tags: newTags,
					};
				})
				.sort((a, b) => {
					return a.title.localeCompare(b.title);
				})
		: sectionTags;
	return {
		distribution: isScreenshotMode
			? randomizeDistribution(distribution)
			: distribution,
		productTitle: title,
		productImage: iconUrl,
		sectionTags: finalSectionTags,
		masteryPercentage,
		numItems,
	};
};

export { getDashboardData };
